<template>
</template>

<script lang="ts">
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import store from '@/store';
import {
  ADD_EVENT_TO_WEET_VIEW_SESSION,
  CREATE_WEET_VIEW_SESSION,
  STOP_WEET_VIEW_SESSION,
} from '@/store/weetview/weetViewAction';
import {weetViewAPI} from '@/store/weetview/weetViewModule';
import {getTenantID} from '@/utils/util';
import throttle from 'lodash/throttle';
import debounce from 'lodash/debounce';
import {WeetParamModel} from '@/store/weetview/weetViewModel';

@Component
export default class WeetViewManager extends Vue {

  @Prop({default: ''})
  private weetID!: string;

  // this is the time to consider a seek
  private timeSeekOffset: number = 5000;

  // store the last time of player to calculate if is seek
  private lastTime: number = 0;


  private endSessionThrottle = throttle(() => {
    this.endSession();
  }, 5000);

  private addEventDebounce = debounce((params: { type: string }) => {
    this.addEventToSession(params);
  }, 1000);

  // For some technical reason, we cannot use store to request server
  // tis is a beacon request, and must be send before the close window
  private endSession() {
    const sessionID = store.getters.getWeetViewCurrentSession;
    const time = Math.round(this.timePlayer);
    if (sessionID === '') {
      return;
    } else {
      navigator.sendBeacon(weetViewAPI + '/' + sessionID + '/' + getTenantID() + '/' + time);
    }
    store.dispatch(STOP_WEET_VIEW_SESSION);
  }


  public mounted() {
    window.addEventListener('unload', this.endSessionThrottle);
  }

  public beforeDestroy() {
    this.endSessionThrottle();
    window.removeEventListener('unload', this.endSessionThrottle);

  }


  get timePlayer(): number {
    return store.getters.getTimerPlayer;
  }

  get currentSessionID(): string {
    return store.getters.getWeetViewCurrentSession;
  }

  get duration(): number {
    return store.getters.getTimeLineDuration;
  }

  @Watch('timePlayer')
  public onTimechange() {

    if (this.timePlayer > this.lastTime + this.timeSeekOffset
        || this.timePlayer < this.lastTime - this.timeSeekOffset) {
      this.addEventDebounce({type: 'SEEK'});
    }
    this.lastTime = this.timePlayer;
  }

  get isPlaying(): boolean {
    return store.getters.isPlaying;
  }

  @Watch('isPlaying')
  private async onChangePlay() {
    if (this.isPlaying) {
      if (this.currentSessionID === '') {
        const weetViewParam = {
          weetID: this.weetID,
        } as WeetParamModel;
        await store.dispatch(CREATE_WEET_VIEW_SESSION, weetViewParam);
      }
      this.addEventDebounce({type: 'PLAY'});
    } else {
      this.addEventDebounce({type: 'PAUSE'});
    }
  }

  // don't call, but call debounce
  private addEventToSession(params: { type: string }) {
    store.dispatch(ADD_EVENT_TO_WEET_VIEW_SESSION, params);
  }
}

</script>

<style scoped lang="scss">
</style>
